import { useUploadFileMutation } from '@/store/api/uploadApi';
import { useGetMyAvtarsQuery, useUpdateProfileImageMutation } from '@/store/api/userApi';
import { Avatar } from '@/types/user';
import { handleApiError, showToastMessage } from '@/utils/helper';
import React, { useState } from 'react';

const useAvatarHook = (onClose: () => void) => {
  const { data: avatarData } = useGetMyAvtarsQuery();
  const [updateProfileImage, { isLoading: isUpdateLoading }] = useUpdateProfileImageMutation();
  const [uploadFile] = useUploadFileMutation();
  const [activeTab, setActiveTab] = useState(1);

  const [selectedAvatar, setSelectedAvatar] = useState<Avatar | null>(null);
  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const [previewImage, setPreviewImage] = useState<string>('');

  const handleFileSelect = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];

    if (!file) return;

    const validTypes = ['image/jpeg', 'image/png', 'image/jpg', 'image/webp'];

    const maxSize = 5 * 1024 * 1024;

    if (!validTypes.includes(file.type)) {
      showToastMessage('error', 'Please upload JPG, PNG or WEBP image');
      return;
    }

    if (file.size > maxSize) {
      showToastMessage('error', 'File must be less than 5MB');
      return;
    }

    setSelectedFile(file);
    setSelectedAvatar(null);

    const preview = URL.createObjectURL(file);

    setPreviewImage(preview);
  };
  const handleSave = async () => {
    try {
      if (selectedFile) {
        const uploadRes = await uploadFile(selectedFile).unwrap();

        await updateProfileImage({
          profileImage: uploadRes.meta.filename,
        }).unwrap();
      }

      if (selectedAvatar) {
        await updateProfileImage({
          profileImage: selectedAvatar.avatarUrl,
        }).unwrap();

        // Better:
        // avatarId: selectedAvatar.id
      }

      showToastMessage('success', 'Profile picture updated successfully');

      handleCloseModal();
    } catch (error) {
      handleApiError(error);
    }
  };
  const handleCloseModal = () => {
    setSelectedAvatar(null);
    setSelectedFile(null);
    setPreviewImage('');
    setActiveTab(1);

    onClose();
  };
  return {
    handleCloseModal,
    handleFileSelect,
    handleSave,
    activeTab,
    selectedFile,
    setSelectedAvatar,
    setSelectedFile,
    setPreviewImage,
    selectedAvatar,
    avatarData,
    previewImage,
    setActiveTab,
  };
};

export default useAvatarHook;
